import { render, staticRenderFns } from "./ManifestDetailPage.vue?vue&type=template&id=7e8332c4&"
import script from "./ManifestDetailPage.vue?vue&type=script&lang=js&"
export * from "./ManifestDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ManifestDetailPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports